import App from '../App.vue'
const login = r => require.ensure([], () => r(require("../page/login/login.vue")), "login");
const loginSms = r => require.ensure([], () => r(require("../page/login/loginSms.vue")), "loginSms");
const agentIndex = r => require.ensure([], () => r(require("../page/agent/agentIndex.vue")), "agentIndex");
const register = r => require.ensure([], () => r(require("../page/login/register.vue")), "register");
const client = r => require.ensure([], () => r(require("../page/agent/client.vue")), "client");
const cooperation = r => require.ensure([], () => r(require("../page/agent/cooperation.vue")), "cooperation");
const newClient = r => require.ensure([], () => r(require("../page/agent/newClient.vue")), "newClient");
const newCooperation = r => require.ensure([], () => r(require("../page/agent/newCooperation.vue")), "newCooperation");
const protocol = r => require.ensure([], () => r(require("../page/login/protocol.vue")), "protocol");

const share = r => require.ensure([], () => r(require("../page/agent/share.vue")), "share");

const accountIndex = r => require.ensure([], () => r(require("../page/account/accountIndex.vue")), "accountIndex");
const integralList = r => require.ensure([], () => r(require("../page/account/integralList.vue")), "integralList");

const contractIndex = r => require.ensure([], () => r(require("../page/contract/contractIndex.vue")), "contractIndex");
const confirmedList = r => require.ensure([], () => r(require("../page/contract/confirmedList.vue")), "confirmedList");
const contractList = r => require.ensure([], () => r(require("../page/contract/contractList.vue")), "contractList");

const cooperationIndex = r => require.ensure([], () => r(require("../page/cooperation/cooperationIndex.vue")), "cooperationIndex");
const cooperationList = r => require.ensure([], () => r(require("../page/cooperation/cooperationList.vue")), "cooperationList");
const internalList = r => require.ensure([], () => r(require("../page/cooperation/internalList.vue")), "internalList");

const safeIndex = r => require.ensure([], () => r(require("../page/safe/safeIndex.vue")), "safeIndex");

const message = r => require.ensure([], () => r(require("../page/message.vue")), "message");
const error = r => require.ensure([], () => r(require("../page/404.vue")), "error");

const rewardIndex = r => require.ensure([], () => r(require("../page/reward/rewardIndex.vue")), "rewardIndex");
const shareQrCord = r => require.ensure([], () => r(require("../page/reward/shareQrCord.vue")), "shareQrCord");
const signIn = r => require.ensure([], () => r(require("../page/reward/signIn.vue")), "signIn");
const signSucess = r => require.ensure([], () => r(require("../page/reward/signSucess.vue")), "signSucess");
const shareReward = r => require.ensure([], () => r(require("../page/reward/shareReward.vue")), "shareReward");
const setReward = r => require.ensure([], () => r(require("../page/reward/setReward.vue")), "setReward");
const activity = r => require.ensure([], () => r(require("../page/reward/activity.vue")), "activity");

export default[{
    path : "",
    component : App, //顶层路由，对应index.html
    children : [{
        path: "/",
        redirect: "account"
    }, {
        path: "account",
        component: accountIndex,
        children: [
            {
                path: "/",
                 redirect: "integralList"
            }, {
                path: "integralList",
                component: integralList
            }
        ],
    }, {
        path: "agent",
        component: agentIndex,
        children: [
            {
                path: "/",
                 redirect: "client"
            }, {
                path: "client",
                component: client
            },{
                path: "cooperation",
                component: cooperation
            },{
                path: "newClient",
                component: newClient
            },{
                path: "newCooperation",
                component: newCooperation
            }
        ],
    },{
        path: "cooperation",
        component: cooperationIndex,
        children: [
            {
                path: "/",
                 redirect: "cooperationList"
            }, {
                path: "cooperationList",
                component: cooperationList
            },{
                path: "internalList",
                component: internalList
            }
        ],
    },{
        path: "safe",
        component: safeIndex,
    },{
        path: "contract",
        component: contractIndex,
        children: [
            {
                path: "/",
                 redirect: "confirmedList"
            }, {
                path: "confirmedList",
                component: confirmedList
            },{
                path: "contractList",
                component: contractList
            }
        ],
    },{
        path: "reward",
        component: rewardIndex,
        children: [
            {
                path: "shareQrCord",
                component: shareQrCord
            },{
                path: "signIn",
                component: signIn
            },{
                path: "signSucess",
                component: signSucess
            },{
                path: "shareReward",
                component: shareReward
            },{
                path: "setReward",
                component: setReward
            }
        ],
    },{
        path: "protocol",
        component: protocol,
    },{
        path: "login",
        component: login
    },{
        path: "loginSms",
        component: loginSms
    },{
        path: "register",
        component: register
    },{
        path: "share",
        component: share 
    },{
        path: "message",
        component: message 
    },{
        path: "activity",
        component: activity 
    },{
        path: "error",
        component: error 
    },{ path: '*', 
        component: error 
    }]
}]


// WEBPACK FOOTER //
// ./src/router/index.js